import CryptoJS from "crypto-js";

const secretKey = process.env.NEXT_PUBLIC_Encryption_KEY!;

export function encryptData(data: any) {
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return {
    iv: iv.toString(CryptoJS.enc.Hex),
    data: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
  };
}

export function decryptData(encryptedData: { iv: string; data: string }) {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Hex.parse(encryptedData.iv);
  const ciphertext = CryptoJS.enc.Hex.parse(encryptedData.data);
  const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext });
  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

export function encryptionJiopc(data: unknown) {
  try {
    const dataString = typeof data === "string" ? data : JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();

    return encrypted;
  } catch(e) {
    console.error("encryptionJiopc error =>>", e);
    return null;
  }
}

export function decryptionJiopc(data: string | null | undefined): string | null {
  try {
    if (!data) return null;

    const bytes = CryptoJS.AES.decrypt(data.trim(), secretKey);
    const parsedData = bytes.toString(CryptoJS.enc.Utf8);

    return parsedData || null;
  } catch (error) {
    console.error("decryptionJiopc error ==>>", error);
    return null;
  }
}

